import Vue from "vue";
import VueRouter from "vue-router";
import authRouter from "./modules/auth";
// import Layout from "@/views/layout/TheLayout.vue";

Vue.use(VueRouter);

export const constantRoutes = [
  {
    path: "/",
    // alias: "/events/all",
    // name: "Events",
    // meta: {
    //   title: "Events",
    // },
    component: { render: c => c("router-view") },
    children: [
      {
        path: "/events/all",
        alias: "/",
        component: () => import("@/components/secured/eventslist/index"),
        name: "Events",
        meta: {
          roles: [
            "Admin",
            "Manager"
          ],
          icon: "mdi-calendar"
        },
      },
      {
        path: "/events/add",
        alias: "/",
        component: () => import("@/components/secured/addevent/index"),
        name: "AddEvent",
        meta: {
          roles: [
            "Admin",
            "Manager"
          ],
          icon: "mdi-calendar"
        },
      },
      {
        path: "/events/:eventId",
        alias: "/",
        component: () => import("@/components/secured/manageevents/index"),
        name: "ManageEvents",
        meta: {
          roles: [
            "Admin",
            "Manager"
          ],
          icon: "mdi-calendar"
        },
      },
      {
        path: "/newappointment/:eventId",
        alias: "/",
        component: () => import("@/components/secured/appointments/newAppointment/index"),
        name: "NewAppointment",
        meta: {
          roles: [
            "Admin",
            "Manager"
          ],
          icon: "mdi-calendar"
        },
      },
      {
        path: "/appointments/:eventId",
        alias: "/",
        component: () => import("@/components/secured/appointments/appointmentslist/index"),
        name: "Appointments",
        meta: {
          roles: [
            "Admin",
            "Manager"
          ],
          icon: "mdi-calendar"
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/organizers",
    name: "Organizers",
    component: { render: c => c("router-view") },
    children: [
      {
        path: "/organizers",
        name: "organizers",
        component: () => import("@/components/secured/organizers/index"),
        meta: {
          roles: [
            "Admin"
          ]
        },
      }
    ]
  },
  {
    path: "/",
    alias: "/event-report",
    name: "EventReport",
    component: { render: c => c("router-view") },
    children: [
      {
        path: "/event-report",
        name: "Event Report",
        component: () => import("@/components/secured/eventreport/index"),
        meta: {
          roles: [
            "Admin",
            "Manager"
          ]
        },
      }
    ]
  },
  {
    path: "/",
    alias: "/usermanagement/list",
    name: "User Management",
    component: { render: c => c("router-view") },
    children: [
      {
        path: "/usermanagement/list",
        name: "UserManagement",
        component: () => import("@/components/secured/UserManagement/UsersList/index"),
        meta: {
          roles: [
            "Admin"
          ]
        },
      },
      {
        path: "/usermanagement/newuser",
        name: "NewUser",
        component: () => import("@/components/secured/UserManagement/NewUser/index"),
        meta: {
          roles: [
            "Admin"
          ]
        },
      },
      {
        path: "/usermanagement/viewuser/:id",
        name: "ViewUser",
        component: () => import("@/components/secured/UserManagement/ViewUser/index"),
        meta: {
          roles: [
            "Admin"
          ]
        },
      }
    ]
  },
  {
    path: "/",
    alias: "/administration/holidaycalendar",
    name: "Holiday Calendar",
    component: { render: c => c("router-view") },
    children: [
      {
        path: "/administration/holidaycalendar",
        name: "HolidayCalendar",
        component: () => import("@/components/secured/holidaycalendar/index"),
        meta: {
          roles: [
            "Admin"
          ]
        },
      }
    ]
  },
  {
    path: "/",
    // alias: "/profile",
    name: "Profile",
    component: { render: c => c("router-view") },
    children: [
      {
        path: "/user-profile",
        component: () => import("@/components/secured/UserProfile/index"),
        name: "profile",
        meta: {
          title: "Profile",
          icon: "mdi-view-dashboard-outline",
          affix: true
        }
      }
    ]
  },
  {
    path: "/",
    alias: "/change-password",
    name: "Change Password",
    component: { render: c => c("router-view") },
    children: [
      {
        path: "/change-password",
        component: () => import("@/components/secured/ChangePassword/index"),
        name: "changePassword",
        meta: {
          title: "Change Password",
          icon: "mdi-view-dashboard-outline",
          affix: true
        }
      }
    ]
  },
  {
    path: "*",
    name: "not-found",
    component: () => import("@/views/widget/AppError.vue")
  },

  ...authRouter
];

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: constantRoutes
});

export const asyncRoutes = [
  { path: "*", redirect: "/error/404", hidden: true }
];
